import React from 'react';

import Skel from '../../components/skel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import HomologationErrorIndicator from './homologation-error';

import * as fmt from '../../utils/fmt';

import styles from './styles.css';

const LabelSubtitle = withStyles({
  root: {
    color: '#8B8B8D',
    textTransform: 'uppercase',
    fontSize: '12px',
  }
})(Typography);

export default function NewCompanyDetails({
  company = {}, history = {}, homologationError = null
}) {
  const loading = !(company.id || history.companyName);

  return <>
    <div className={styles.sectionTitleWrapper}>
      <Typography style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '0px' }}>
        Dados da Empresa
      </Typography>
      <hr style={{ margin: 0, borderColor: '#8B8B8D', borderWidth: '1px' }} />
    </div>

    <Grid
      spacing={24}
      container
      style={{ fontSize: '14px', fontWeight: 'bold', padding: '0rem 5px' }}
    >
      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Nome
          </LabelSubtitle>
          <Skel loading={loading}>
            {history.companyName || company.name || '-'}
          </Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            CNPJ
          </LabelSubtitle>
          <Skel loading={loading}>
            {fmt.cnpj(history.companyCNPJ || company.cnpj || '') || '-'}
          </Skel>
        </div>
      </Grid>

      <HomologationErrorIndicator loading={loading} error={homologationError} />
    </Grid>

    <div style={{ marginBottom: '16px', marginTop: '16px' }}>
      <Typography style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '0px' }}>
        Contato
      </Typography>
      <hr style={{ margin: 0, borderColor: '#8B8B8D', borderWidth: '1px' }} />
    </div>

    <Grid
      spacing={24}
      container
      style={{ fontSize: '14px', fontWeight: 'bold', padding: '0rem 5px' }}
    >
      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Endereço
          </LabelSubtitle>
          <Skel loading={loading}>
            {history.companyAddress || (company.place && company.place.name) || '-'}
          </Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Cidade
          </LabelSubtitle>
          <Skel loading={loading}>
            {history.companyCity || (company.city && company.city.name) || '-'}
          </Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Estado
          </LabelSubtitle>
          <Skel loading={loading}>
            {history.companyState || (company.city && company.city.state.abbrev) || '-'}
          </Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Telefone
          </LabelSubtitle>
          <Skel loading={loading}>
            {history.companyPhone ||
              (company.phones && company.phones.map(rec => rec.phone).join(', ')) ||
              '-'}
          </Skel>
        </div>
      </Grid>
    </Grid>
  </>;
}
